/*
 * Posts Collection rails (sections/posts-collection.liquid).
 *
 * Liquid server-renders each rail from the newest 250 posts plus the section's
 * "Older articles" picks, so crawlers see the cards without JS. Rails that are
 * still short (rare tags, nothing picked yet) are topped up from the Storefront API:
 *  - one aliased query for every short rail (was one serial request per rail),
 *  - fired only once a short rail comes near the viewport,
 *  - same-origin endpoint (no CORS preflight),
 *  - resized thumbnails via url(transform:) + srcset (was the full-size upload),
 *  - appends only the missing articles, so server cards (and their images) stay put.
 *
 * Every section instance includes this file; the guard makes it run once.
 */
(function () {
  if (window.TFPostsCollection) return;

  var SELECTOR = '[data-section-type="posts-collection"]';
  var BLOG_TITLE = 'Trident Fly Fishing';
  var API_URL = '/api/2025-10/graphql.json';
  var IMAGE_SIZES = '(max-width: 640px) 82vw, (max-width: 999px) 50vw, 360px';
  var IMAGE_WIDTHS = [300, 450, 600, 900];

  var ARTICLE_FRAGMENT =
    'fragment PostCard on Article {' +
    ' title handle excerpt(truncateAt: 150) content(truncateAt: 300) publishedAt tags onlineStoreUrl' +
    ' authorV2 { name }' +
    ' image { altText width height ' +
    IMAGE_WIDTHS.map(function (w) { return 'u' + w + ': url(transform: {maxWidth: ' + w + '})'; }).join(' ') +
    ' }' +
    '}';

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Mirrors Shopify's handleize for author page links
  function handleize(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function panelOf(section) {
    return section.querySelector('.tab-articles__panel');
  }

  function settingsOf(section) {
    var panel = panelOf(section);
    return {
      tag: panel.getAttribute('data-posts-tag') || '',
      limit: parseInt(panel.getAttribute('data-articles-per-collection'), 10) || 6,
      needsFetch: panel.getAttribute('data-needs-fetch') === 'true',
      backgroundColor: panel.getAttribute('data-background-color') || '#ffffff',
      show_category: panel.getAttribute('data-show-category') === 'true',
      show_author: panel.getAttribute('data-show-author') === 'true',
      show_date: panel.getAttribute('data-show-date') === 'true',
      show_excerpt: panel.getAttribute('data-show-excerpt') === 'true'
    };
  }

  // Keep in sync with the server-rendered card in sections/posts-collection.liquid
  function cardHTML(article, settings) {
    var url = article.onlineStoreUrl || '/blogs/all/' + article.handle;
    var title = escapeHtml(article.title);
    var image = '';
    if (article.image) {
      var srcset = IMAGE_WIDTHS
        .filter(function (w, i) { return i === 0 || w <= (article.image.width || w); })
        .map(function (w) { return article.image['u' + w] + ' ' + w + 'w'; })
        .join(', ');
      image =
        '<a href="' + url + '" class="article-item__image-container">' +
        '<img src="' + article.image.u600 + '" srcset="' + srcset + '" sizes="' + IMAGE_SIZES + '"' +
        (article.image.width ? ' width="' + article.image.width + '" height="' + article.image.height + '"' : '') +
        ' alt="' + escapeHtml(article.image.altText || article.title) + '" loading="lazy" class="article-item__image">' +
        '</a>';
    }

    var meta = [];
    if (settings.show_category && article.tags.length > 0) {
      meta.push('<span class="article-item__meta-item">' + escapeHtml(article.tags[0]) + '</span>');
    }
    if (settings.show_author) {
      var author = (article.authorV2 && article.authorV2.name) || 'Anonymous';
      meta.push('<a href="/pages/authors/' + handleize(author) + '" class="article-item__meta-item">By ' + escapeHtml(author) + '</a>');
    }
    if (settings.show_date) {
      var date = new Date(article.publishedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
      meta.push('<time class="article-item__meta-item">' + date + '</time>');
    }

    var excerpt = article.excerpt || article.content || '';
    if (excerpt.length > 80) excerpt = excerpt.substring(0, 80) + '...';

    return (
      '<div class="article-list__item" data-handle="' + escapeHtml(article.handle) + '">' +
      '<div class="article-item" style="background-color: ' + escapeHtml(settings.backgroundColor) + ';">' +
      image +
      '<h3 class="article-item__title heading h4"><a href="' + url + '" class="link">' + title + '</a></h3>' +
      (meta.length ? '<div class="article-item__meta">' + meta.join('') + '</div>' : '') +
      (settings.show_excerpt && excerpt ? '<div class="article-item__excerpt rte">' + escapeHtml(excerpt) + '</div>' : '') +
      '</div></div>'
    );
  }

  function fetchRails(sections) {
    var parts = sections.map(function (section, i) {
      var s = settingsOf(section);
      var filter = 'blog_title:"' + BLOG_TITLE + '"' + (s.tag ? ' AND tag:"' + s.tag + '"' : '');
      return 'r' + i + ': articles(first: ' + s.limit + ', query: ' + JSON.stringify(filter) +
        ', sortKey: PUBLISHED_AT, reverse: true) { nodes { ...PostCard } }';
    });
    var query = 'query PostsCollectionRails { ' + parts.join(' ') + ' } ' + ARTICLE_FRAGMENT;

    return fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query })
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) { return (json && json.data) || null; })
      .catch(function () { return null; });
  }

  function fillRail(section, articles) {
    var s = settingsOf(section);
    var list = section.querySelector('.article-list');
    if (!list) return;

    var present = {};
    list.querySelectorAll('.article-list__item[data-handle]').forEach(function (el) {
      present[el.getAttribute('data-handle')] = true;
    });
    var count = Object.keys(present).length;

    var html = '';
    (articles || []).forEach(function (article) {
      if (count >= s.limit || present[article.handle]) return;
      html += cardHTML(article, s);
      count++;
    });

    list.querySelectorAll('.article-list__item--placeholder').forEach(function (el) { el.remove(); });
    if (html) {
      var empty = list.querySelector('.tab-articles__empty');
      if (empty) empty.remove();
      list.insertAdjacentHTML('beforeend', html);
    } else if (count === 0 && !list.querySelector('.tab-articles__empty')) {
      var emptyText = panelOf(section).getAttribute('data-empty-text') || '';
      list.insertAdjacentHTML('beforeend', '<div class="tab-articles__empty"><p class="text--subdued">' + escapeHtml(emptyText) + '</p></div>');
    }
    panelOf(section).setAttribute('data-needs-fetch', 'false');
    initSlider(section);
  }

  function loadRails(sections) {
    fetchRails(sections).then(function (data) {
      sections.forEach(function (section, i) {
        var nodes = data && data['r' + i] ? data['r' + i].nodes : null;
        // On a failed request keep whatever the server rendered
        if (nodes) {
          fillRail(section, nodes);
        } else {
          section.querySelectorAll('.article-list__item--placeholder').forEach(function (el) { el.remove(); });
          initSlider(section);
        }
      });
    });
  }

  // Slider: one controller per section; re-running it just recounts the items.
  var sliders = new WeakMap();

  function initSlider(section) {
    var container = section.querySelector('.article-slider-container');
    if (!container) return;
    var existing = sliders.get(section);
    if (existing) {
      existing.refresh();
      return;
    }

    var list = container.querySelector('.article-list');
    var prevBtn = container.querySelector('.article-slider__nav--prev');
    var nextBtn = container.querySelector('.article-slider__nav--next');
    var index = 0;

    function itemsToShow() {
      if (window.innerWidth <= 640) return 1;
      if (window.innerWidth <= 999) return 2;
      return 3; // shows 3.2
    }
    function itemWidth() {
      if (window.innerWidth <= 640) return 100;
      if (window.innerWidth <= 999) return 50;
      return 25;
    }
    function maxIndex() {
      var count = list.querySelectorAll('.article-list__item:not(.article-list__item--placeholder)').length;
      return Math.max(0, count - itemsToShow());
    }
    function update() {
      index = Math.min(index, maxIndex());
      list.style.transform = 'translateX(' + -(index * itemWidth()) + '%)';
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index >= maxIndex();
      prevBtn.style.opacity = prevBtn.disabled ? '0.5' : '1';
      nextBtn.style.opacity = nextBtn.disabled ? '0.5' : '1';
    }

    prevBtn.addEventListener('click', function () {
      if (index > 0) { index--; update(); }
    });
    nextBtn.addEventListener('click', function () {
      if (index < maxIndex()) { index++; update(); }
    });
    window.addEventListener('resize', update);

    sliders.set(section, { refresh: update });
    update();
  }

  function init(root) {
    var sections = Array.prototype.slice.call((root || document).querySelectorAll(SELECTOR));
    if (root && root.matches && root.matches(SELECTOR)) sections.push(root);
    if (!sections.length) return;

    sections.forEach(initSlider);

    var pending = sections.filter(function (section) { return settingsOf(section).needsFetch; });
    if (!pending.length) return;

    if (!('IntersectionObserver' in window)) {
      loadRails(pending);
      return;
    }
    // One request for every short rail, sent when the first one nears the viewport
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      observer.disconnect();
      loadRails(pending);
    }, { rootMargin: '600px 0px' });
    pending.forEach(function (section) { observer.observe(section); });
  }

  window.TFPostsCollection = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders a section in place
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
